import React from 'react';
import styles from './Form.module.css';

export interface FormInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
  className?: string;
}

const FormInput: React.FC<FormInputProps> = ({ 
  error = false,
  className = '',
  ...props 
}) => {
  return (
    <input
      className={`${styles.input} ${error ? styles.inputError : ''} ${className}`}
      {...props}
    />
  );
};

export default FormInput;

